import { useNavigate, useSearch } from '@tanstack/react-router'
import { SalesScreen } from '@features/sales'
import type { SalesSearch } from '@features/sales'

export function VendasPage() {
  const search = useSearch({ from: '/protected/vendas' })
  const navigate = useNavigate()

  return (
    <SalesScreen
      search={search}
      onSearchChange={(next: SalesSearch) => {
        void navigate({ to: '/vendas', search: next, replace: true })
      }}
      onViewSubscription={(subscriptionId: string) => {
        void navigate({ to: '/assinaturas', search: { sub: subscriptionId } })
      }}
    />
  )
}
